export const model = {
  code: '',
  description: '',
};
